import { Component, EventEmitter, Inject, Output, ViewChild } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { TBotItem } from '@core/interfaces/TBotItem';

import { BotEditorComponent } from '../../bot-editor/bot-editor.component';

@Component({
    selector: 'app-bot-edit-modal',
    templateUrl: './bot-edit-modal.component.html',
    styleUrls: ['./bot-edit-modal.component.scss'],
    standalone: true,
    imports: [BotEditorComponent, MatButton]
})
export class BotEditModalComponent {
  @ViewChild(BotEditorComponent, { static: false }) botEditorComponent!: BotEditorComponent;
  @Output() public saveCallback = new EventEmitter<TBotItem>();
  @Output() public cancelCallback = new EventEmitter();
  formValid = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: TBotItem,
    private dialogRef: MatDialogRef<BotEditModalComponent>
  ) {}

  protected close(): void {
    this.cancelCallback.emit();
    this.dialogRef.close();
  }

  protected save(updated: TBotItem): void {
    this.saveCallback.emit(updated);
    this.dialogRef.close();
  }

  protected triggerSave(): void {
    if (this.botEditorComponent) {
      this.botEditorComponent.saveBotConfig();
    } else {
      console.error('BotEditorComponent not initialized');
    }
  }

  protected updateFormValid(isValid: boolean): void {
    this.formValid = isValid;
  }
}
